module.exports = __webpack_public_path__ + "img/galeria_stack_6.c4b9933d.png";